import {ShowHide} from './Helpers'

let obj = Object.assign(new ShowHide(true),{});

export default obj;